export default __webpack_public_path__ + "static/1026-46d53f5f226393daf3e74a6f805d6c19.gif";